import React from 'react';
import { AjusteDeParaContent } from './ajusteDeParaContent';
import { AjusteDeParaProvider } from './context/ajusteDeParaContext';

export const AjusteDePara: React.FC = () => {
  return (
    <AjusteDeParaProvider>
      <AjusteDeParaContent />
    </AjusteDeParaProvider>
  );
};
